
<template>
  <div cy-id="album-search">
    <v-row>
      <v-col sm="12">
        <v-text-field label="Spotify album id" v-model="query"></v-text-field>
      </v-col>
    </v-row>
    <BuilderAlbumTile v-model="query">
      <v-btn color="green" dark slot="button" @click="add" cy-id="add">
        Add
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </BuilderAlbumTile>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import BuilderAlbumTile from './BuilderAlbumTile.vue'

@Component({
  components: { BuilderAlbumTile }
})
export default class BuilderAlbumSearch extends Vue {
  query = ''

  add () {
    this.$emit('add', this.query)

    this.query = ''
  }
}
</script>

<style scoped></style>
